import {createUseQuery, QueryHookOptions} from "@irati/utils/services/apollo"
import {
  FlexiPointsExpiry,
  PaymentCurrencyType,
  QueryFlexiPointsExpiryListArgs,
  QueryTopupCurrencyCodeArgs,
  QueryWalletArgs,
  Wallet,
  WalletEntityType
} from "@irati/types"

import useAuth from "@irati/auth/helpers/auth/useAuth"
import {gql} from "@irati/utils/gql"
import walletQuery from "../graph/query/wallet"
import flexiPointsExpiryList, {flexiPointsExpiryListKey} from "../services/queries/flexiPointsExpiryList"
import walletErrorHandler from "../services/errors/walletErrorHandler"
import {NextTopup, WalletFragment} from "../graph/fragments/fullWallet"
import topupCurrencyCode, {topupCurrencyCodeKey} from "../services/queries/getCurrencyCode"

export const useWalletQuery = createUseQuery<Wallet, QueryWalletArgs>(walletQuery, {
  key: "wallet",
  errorHandlers: [walletErrorHandler]
})

export const useWalletCashQuery = ({fetchPolicy, skip}: Pick<QueryHookOptions, "fetchPolicy" | "skip"> = {}) => {
  const userId = useAuth().user?.uuid ?? ""
  const hasCashWallet = !!useAuth().productPermissions?.wallet?.users

  return useWalletQuery(
    {userId, currency: PaymentCurrencyType.Gbp, entityType: WalletEntityType.User, entityId: userId},
    {fetchPolicy, skip: skip || !hasCashWallet || !userId}
  )
}

export const useFlexiPointsExpiryQuery = createUseQuery<FlexiPointsExpiry, QueryFlexiPointsExpiryListArgs>(flexiPointsExpiryList, {
  key: flexiPointsExpiryListKey
})

export const useWalletWithNextTopupQuery = createUseQuery<Wallet, QueryWalletArgs>(
  gql`
    query WalletWithTopup($userId: String!, $currency: String!, $entityId: ID, $entityType: WalletEntityType) {
      wallet(userId: $userId, entityId: $entityId, currency: $currency, entityType: $entityType) {
        ...WalletFragment
        ...NextTopup
      }
    }

    ${WalletFragment}
    ${NextTopup}
  `,
  {
    key: "wallet",
    errorHandlers: [walletErrorHandler]
  }
)

export const useTopupCurrencyQuery = createUseQuery<string, QueryTopupCurrencyCodeArgs>(topupCurrencyCode, {
  key: topupCurrencyCodeKey
})
